import { componentConfig, componentLoader } from "@rankers/lib/component_initializer";
import { RatingsGraph } from "./ratings_graph";

export const ratingsGraphLoader = function (options = {}) {
    componentLoader(componentConfig(RatingsGraph, RatingsGraph.config.componentTypeKey, RatingsGraph.config.baseHtmlClass), options);
};